module.exports = __webpack_public_path__ + "9277cdc369a2c97cd35046688f4a4833.svg";